import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PageContent } from 'src/pages/page-content.js';
import 'src/utilities/display-alert';
import '../../content/d-entity-header.js';
import '../../library/components/d-help-section.js';
import '../../library/elements/d-action.js';
import type { PageViewModel } from '@trinnvis/dabih-api-client';
import { features } from '../../store/selectors/features/features';
import type { PartnersPageViewModel } from './partners-page-view-model';

/**
 *
 */
@customElement('d-partners-page-content')
export class DPartnersPageContent extends PageContent<PartnersPageViewModel> {
  @property({ type: Array })
  pages: PageViewModel[] = [];
  @property({ type: Boolean, attribute: 'write-access', reflect: true })
  writeAccess = false;
  @property({ type: Boolean })
  editMode = false;
  @property({ type: Object })
  token = {};
  @property({ type: Boolean })
  uncoverPageMenu = false;
  @property({ type: String })
  key = '';
  @property({ type: Number })
  organizationId = 0;

  renderContent() {
    if (this.pageView.promoData) {
      return html` <d-promo-section
        theme-page
        .employeesCount=${this.pageView.employeesCount}
        .specialTerms=${this.pageView.specialTerms}
        .promoData=${this.pageView.promoData}
        .features=${features}
      ></d-promo-section>`;
    }
    return html`
      <d-list-section
        no-header
        field="organization_partners"
        .writeAccess=${this.writeAccess}
        theme-page
        .items=${this.pageView.partnersAndContacts}
        .contentStickyTop=${this.contentStickyTop}
      >
      </d-list-section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-partners-page-content': DPartnersPageContent;
  }
}
